<template>
  <div class="vocation-dep">
    <div class="g-box">
      <div class="t1">{{ dataInfo.tips }}</div>
      <div class="t2">{{ dataInfo.name }}</div>
    </div>
    <div class="content clearfix">
      <div
        class="swiper-container"
        id="swiper-dep"
        style="padding:150px 0 200px 0"
      >
        <div class="swiper-wrapper">
          <div
            class="item swiper-slide"
            v-for="item in contentList"
            :key="item.id"
          >
            <img class="img" :src="item.image" alt="" />
            <div class="orcal" @click="toDetail(item)">
              <div>
                <div class="name">{{ item.tips }}</div>
                <div class="line"></div>
                <div class="address">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import Swiper from "swiper/swiper-bundle";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 99,
      menuId: this.menuId
    });
    this.$nextTick(() => {
      new Swiper("#swiper-dep", {
        slidesPerView: 4,
        autoplay: {
          delay: 3000
        }
      });
    });
    this.contentList = data;
    this.dataInfo = dataInfo;
  },
  methods: {
    toDetail(item) {
      if (!item.url) return;
      window.open(item.url);
    }
  }
};
</script>
<style lang="less">
.vocation-dep {
  padding-top: 164px;
  padding-bottom: 150px;
  box-sizing: border-box;
  .t1 {
    font-size: 72px;
    font-family: "en-tit";
    color: #000;
    line-height: 87px;
  }
  .t2 {
    font-size: 48px;
    font-family: Dream-LiHeiGB, Dream;
    color: #000;
    line-height: 54px;
  }
  .content {
    .item {
      position: relative;
      margin-right: 30px;
      width: calc(25% - 30px);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 12px;
      float: left;
      cursor: pointer;
      transition: all 0.3s;
      .img {
        width: 100%;
        height: auto;
      }
      .orcal {
        position: absolute;
        right: 60px;
        bottom: -120px;
        opacity: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background: #fff;
        transition: all 0.3s;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.21);
        .name {
          text-align: center;
        }
        .line {
          margin: 22px auto 0;
          width: 108px;
          height: 1px;
          background-color: #979797;
        }
        .address {
          padding-top: 10px;
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          color: #2c6fff;
        }
      }
    }
    .item:hover {
      // width: calc(31.25% - 30px);
      transform: scale(1.25);
      z-index: 2;
      .orcal {
        opacity: 1;
      }
    }
  }
}
</style>
